import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=a8baa566"
import script from "./Landing.vue?vue&type=script&lang=ts"
export * from "./Landing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8baa566')) {
      api.createRecord('a8baa566', component.options)
    } else {
      api.reload('a8baa566', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=a8baa566", function () {
      api.rerender('a8baa566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Landing.vue"
export default component.exports